<div class="dialog-container">
  <div class="dialog-heading">
    <h2 mat-dialog-title>{{'test.createTest.heading' | translate}}</h2>
    <span class="spacer"></span>
    <div class="btn-close">
        <button mat-icon-button mat-dialog-close aria-label="Close Dialog"><mat-icon>close</mat-icon></button>
    </div>
  </div>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="basicDetailsForm" novalidate>
    <div class="form-wrapper">
      <div class="input-wrapper">
        <div class="input-label">
          <label>{{'test.createTest.labelName' | translate}}</label><span class="required">*</span>
        </div>
        <div class="input-field">
          <textarea class="form-control textarea" rows="2" maxlength="121" type="text" formControlName="testTitle" (focus)='onTestNameControlFocus()'></textarea>
          <div *ngIf="f.testTitle.invalid && (f.testTitle.dirty || f.testTitle.touched) && !f.testTitle.errors?.whitespace" class="alert alert-danger" >
            <div  *ngIf="f.testTitle.errors?.required">{{'test.createTest.nameError1' | translate}}</div>
            <div  *ngIf="f.testTitle.errors?.minlength">{{'test.createTest.nameError2' | translate}}</div>
            <div  *ngIf="f.testTitle.errors?.maxlength">{{'test.createTest.nameError3' | translate}}</div>
            <div  *ngIf="f.testTitle.errors?.pattern">{{'test.createTest.nameError4' | translate}}</div>
          </div>
        </div>
      </div>
      <div class="input-wrapper">
        <div class="input-label">
          <label>{{'test.createTest.labelDesc' | translate}}</label>
        </div>
        <div class="input-field">
          <textarea type="text" rows="8" maxlength="481" class="form-control textarea" type="text" formControlName="testDescription"></textarea>
          <div *ngIf="f.testDescription.invalid  && (f.testDescription.dirty || f.testDescription.touched)" class="alert alert-danger">
            <div *ngIf="f.testDescription.errors?.minlength">{{'test.createTest.descError1' | translate}}</div>
            <div *ngIf="f.testDescription.errors?.maxlength">{{'test.createTest.descError2' | translate}}</div>
          </div>
        </div>
      </div>
      <div class="input-wrapper">
        <div class="input-label">
          <label>{{'items.NewItem.scoringType' | translate}} <span class="required">*</span></label>
        </div>
        <div class="input-field">
          <select aria-placeholder="Style group" class="form-control ng-untouched ng-pristine ng-valid"
            ng-reflect-model="" formControlName="scoringTypeId" [(ngModel)]="selectedScoringType"
            (change)="changeScoringType(selectedScoringType)">
            <option *ngFor="let option of scoringTypes" [value]="option?.scoringTypeId" >
              {{option?.scoringTypeName}}
            </option>
          </select>
        </div>
      </div>

      <div class="input-wrapper" *ngIf="isStyleGroupShow">
        <div class="input-label">
          <label>{{'items.NewItem.styleGroup' | translate}} <span class="required">*</span></label>
        </div>
        <div class="input-field">
          <select aria-placeholder="Style group" class="form-control ng-untouched ng-pristine ng-valid"
            ng-reflect-model="" formControlName="styleGroupId">
            <option *ngFor="let option of styleGroupData" [value]="option?.styleGroupId">
              {{option?.styleGroupName}}
            </option>
          </select>
        </div>
        <div *ngIf="f.styleGroupId.invalid && (f.styleGroupId.touched)" class="alert alert-danger">
          <div *ngIf="f.styleGroupId.errors?.required">{{'items.NewItem.styleGroupError1' | translate}} </div>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <!-- <button mat-flat-button  color="" class="btn-primary" aria-label="Save"  (click)="saveBasicTestDetails()"
    [disabled]='basicDetailsForm.invalid'>Save</button> -->
    <button mat-flat-button  color="" class="btn-primary" aria-label="Save"  (click)="saveBasicTestDetails()"
    [disabled]='(f.testTitle.invalid || f.testDescription.invalid || f.scoringTypeId.invalid || f.styleGroupId.invalid)'>{{'items.NewItem.btnSave' | translate}}</button>
</mat-dialog-actions>
</div>


<!-- <div class="btn-wrapper">
  <button (click)="saveBasicTestDetails()" mat-raised-button class="btn-bg-color"
    [disabled]='basicDetailsForm.invalid'>Save</button>
</div>

<div class="frm-container">
  <form [formGroup]="basicDetailsForm" novalidate>
    <div class="input-class">
      <label>Test name<span class="red-asterisk">*</span></label>
      <input class="form-control" maxlength="121" type="text" formControlName="testTitle" (focus)='onTestNameControlFocus()'>
      <div *ngIf="f.testTitle.invalid && (f.testTitle.dirty || f.testTitle.touched)" class="alert alert-danger">
        <div *ngIf="f.testTitle.errors?.required"> Test name is required. </div>
        <div *ngIf="f.testTitle.errors?.minlength"> Minimum 3 characters required. </div>
        <div *ngIf="f.testTitle.errors?.maxlength"> Maximum 120 characters allowed.  </div>
      </div>
    </div>
    <div class="input-class">
      <label>Test description</label>
      <textarea type="text" maxlength="481"class="form-control textarea" type="text" formControlName="testDescription"></textarea>
      <div *ngIf="f.testDescription.invalid && (f.testDescription.dirty || f.testDescription.touched)" class="alert alert-danger">
        <div *ngIf="f.testDescription.errors?.minlength"> Minimum 20 characters required. </div>
        <div *ngIf="f.testDescription.errors?.maxlength"> Maximum 480 characters allowed.  </div>
      </div>
    </div>
  </form> -->

